import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { SignatureComponent } from "./signature.component";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class SignatureModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = () => {
		return this.modalController.create({
			id: SignatureComponent.modalId,
			cssClass: this.rideOpsUi.isV2Active() ? "signature-modal signature-modal-v2" : "signature-modal",
			component: SignatureComponent,
		});
	};
}
